var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotlight201({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.85,12.95C6.12,12.95,3.9,10.73,3.9,8s2.22-4.95,4.95-4.95S13.8,5.27,13.8,8S11.58,12.95,8.85,12.95z  M8.85,3.55C6.4,3.55,4.4,5.55,4.4,8s2,4.45,4.45,4.45s4.45-2,4.45-4.45S11.3,3.55,8.85,3.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "10.82,10.32 6.73,6.23 7.08,5.88 11.18,9.96  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.85,14.64C5.19,14.64,2.2,11.66,2.2,8s2.98-6.65,6.65-6.65v0.5C5.46,1.85,2.7,4.61,2.7,8 c0,3.39,2.76,6.14,6.15,6.14V14.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.97,
    y: 7.76,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.0707 8.5977)",
    className: "st2",
    width: 5.75,
    height: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlight201);
export default __webpack_public_path__ + "static/media/Spotlight2-01.009eddca42bde754f9ba71fa5803eb38.svg";
export { ForwardRef as ReactComponent };